export default __webpack_public_path__ + "static/media/dairy.bde15aee.svg";